export const STAYS_TYPEAHEAD = 'STAYS_TYPEAHEAD';
export const STAYS_LOCATION_SEARCH = 'STAYS_LOCATION_SEARCH';
